/* Waypoints sticky header menu */
if ($('.header.js-header').length) { // No .header on MAPI
    var waypoint = new Waypoint({
        element: $('.header.js-header'),
        handler: function(direction) {
            var navElement = $('.nav-sticky');
            if (direction === 'down') {
                $('body').addClass('sticky-nav-on');
                navElement.removeClass("hide");
                var _tmp1 = $(document).trigger("stickyNav:on");
            } else {
                $('body').removeClass('sticky-nav-on');
                navElement.addClass("hide");
                var _tmp2 = $(document).trigger("stickyNav:off");
            }
        },
        offset: function() {
            return  - $(this.element).height();
        }
    });
}